'use client';

import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ArticleCardData } from '@telialt/core-cms-content/src/components/ArticleCard/model';

import { ArticleCardsListFactory } from '../Common/ArticleCardsList/ArticleCardsListFactory';
import { PaginationQuery } from '../Common/ArticleCardsList/model';
import { CardsListWrapper, SelectorWrapper } from './BlogAuthorPage.styles';

type Props = { pageTitle: string; articles: ArticleCardData[]; totalItems: number } & PaginationQuery;

export const AuthorArticleCardsList: FC<Props> = ({ pageTitle, ...controls }) => {
    const { t } = useTranslations();
    const { CardsList, SortSelector, NotFound } = ArticleCardsListFactory(controls);

    const { totalItems } = controls;
    if (!totalItems) {
        return <NotFound description={t['blog.articles_not_found.for_author']} />;
    }

    return (
        <CardsListWrapper>
            <SelectorWrapper>
                <SortSelector />
            </SelectorWrapper>
            <CardsList />
        </CardsListWrapper>
    );
};
